import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { isPaywallDisabled } from '../../shared/config/paywall';

export const TrialBanner: React.FC = () => {
  const navigate = useNavigate();
  const { subscription, daysLeftInTrial, isActive } = useSubscription();

  if (isPaywallDisabled()) return null;
  if (!subscription || subscription.status !== 'trialing' || !isActive) {
    return null;
  }
  const days = daysLeftInTrial ?? 0;
  if (days <= 0) return null;

  return (
    <div className="trial-banner" role="status">
      <Sparkles size={16} className="trial-banner__icon" aria-hidden />
      <span>
        <strong>{days}</strong> day{days === 1 ? '' : 's'} left in your free trial.
      </span>
      <button type="button" className="trial-banner__cta" onClick={() => navigate('/pricing')}>
        Upgrade
      </button>
    </div>
  );
};
